import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';
import { IConflictCheck, IConflictCheckParams } from '../interface/conflictCheck';
import { useAnalytics } from './useAnalytics';
import { AnalyticsFeatureOperation } from '../interface/analytics';

const createConflictCheck = async (
  conflictCheckData: IConflictCheckParams,
): Promise<IConflictCheck> => {
  return post(`${API_URLS.CREATE_CONFLICT_CHECK}`, conflictCheckData);
};

export const useCreateConflictCheck = (): UseMutationResult<
  IConflictCheck,
  AxiosError<{ message?: string; type?: string }>,
  { conflictCheckData: IConflictCheckParams }
> => {
  const { setIsLoading } = useLoading();
  const { t } = useTranslation();
  const { trackBusinessEvent } = useAnalytics();

  return useMutation({
    mutationFn: ({ conflictCheckData }) => createConflictCheck(conflictCheckData),
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      trackBusinessEvent(AnalyticsFeatureOperation.CONFLICT_CHECK_CREATION);
      showToast('success', t('conflict:conflictCheckCreated'));
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
